export class ConfigCesion {
   emisorId: string;
   diasVencimiento: number;
}
